// TODO: repair typing
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import React, { useEffect, useState } from 'react';
import { Skeleton, Modal } from 'antd';
import { Profil } from 'types';
import { useDispatch, useSelector } from 'react-redux';
import { FormikValues } from 'formik';
import history from '../../app-router/history';
import ProfilList from '../../components/templates/profil-list';
import ButtonPrimary from '../../components/molecules/button-primary';

import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import { isRequestError } from 'common/utils/error';
import {
  ProfilesSelectors,
  UserInfoSelectors,
  ProfilesActions,
  ProfilActions,
  ProfilSelectors,
  ClearStateSliceActions,
} from '../../common/config/store';
import ModalContentConfirm from '../../components/organisms/modal-content-confirm';
import MessageModal from '../../components/organisms/message-modal';

import { StyledMainTitle, StyledListUtil } from '../../common/styling/mixins';

export interface State {
  id?: string;
  userName?: string;
}

const { StyledListWrapper, StyledListTitleWrapper, StyledListButtonWrapper, StyledListBoldWrapper } = StyledListUtil;

const UsersList: React.FC<State> = () => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const [modalVisible, setModalVisible] = useState(false);
  const [profil, setProfil] = useState({ id: '', name: '' });
  const [filterValues, setFilterValues] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const status = useSelector(ProfilesSelectors.statusSelector);
  const canWriteProfiles = useSelector(UserInfoSelectors.hasWriteAccess('Profiles'));
  const error = useSelector(ProfilSelectors.errorSelector);
  const errorType = useSelector(ProfilSelectors.errorTypeSelector);

  useEffect(() => {
    dispatch(ProfilesActions.fetchPofiles());
  }, [dispatch]);

  useEffect(() => {
    if (errorType && errorType === 'delete') setShowDeleteModal(true);
  }, [errorType]);

  const onModalConfirm = (shouldRemove: boolean) => {
    if (shouldRemove) {
      dispatch(ProfilActions.deleteProfil({ id: profil.id }));
    }
    setModalVisible(false);
  };

  const onClickCreateHandler = (): void => {
    return history.push('/profil');
  };

  const onClickEditHandler = (record: object): void => {
    return history.push(`/profil/${record?.id}`);
  };
  const onClickDeleteHandler = (record: Profil): void => {
    setProfil({ id: record.id, name: record.name });
    setModalVisible(true);
  };

  const onSubmitHandler = (values: FormikValues) => {
    setFilterValues(values);
  };
  return (
    <div>
      <Modal
        title={t('Modal', 'USER_MODAL_TITLE')}
        footer={null}
        open={modalVisible}
        onCancel={() => onModalConfirm(false)}
      >
        <ModalContentConfirm
          title={
            <div>
              {t('Modal', 'PROFIL_DELETE_CONFIRM')}
              <StyledListBoldWrapper>{profil.name}</StyledListBoldWrapper>
            </div>
          }
          onConfirm={onModalConfirm}
        />
      </Modal>

      <MessageModal
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Profil' }));
        }}
        errorMessage={error && isRequestError(error) ? undefined : error}
      />

      <Layout />
      <StyledListWrapper>
        <StyledListTitleWrapper>
          <StyledMainTitle>{t('ProfilPage', 'PROFIL_RESEARCH_PAGE_H2')}</StyledMainTitle>
          {canWriteProfiles && (
            <StyledListButtonWrapper>
              <ButtonPrimary onClick={onClickCreateHandler}>{t('Buttons', 'NEW_PROFIL_CREATION_BUTTON')}</ButtonPrimary>
            </StyledListButtonWrapper>
          )}
        </StyledListTitleWrapper>
        {status === 'loading' && <Skeleton />}
        {status === 'success' && (
          <ProfilList
            canWrite={canWriteProfiles}
            onSubmitHandler={onSubmitHandler}
            onClickEdit={onClickEditHandler}
            onClickDelete={onClickDeleteHandler}
            filterValues={filterValues}
          />
        )}
      </StyledListWrapper>
    </div>
  );
};
export default UsersList;
